<template>
  <div class="ds-control mobile dsf_teas_student_twobring">
    <div class="two_bring-content">
      <div
        class="two_bring-content-item"
        v-for="(item, index) in list"
        :class="index == 0 ? 'itemnomargintop' : ''"
        :key="'twobring' + index"
      >
        <div class="question">{{ item.title }}</div>
        <div class="leftlump"></div>
        <div class="errormessage">{{ item.errorMessage }}</div>
        <div class="questiontypes">
          <div
            class="typeItem"
            v-for="(childItem, typeindex) in item.child"
            :key="'type' + typeindex"
            :class="typeindex == 0 ? 'typeItemno' : ''"
          >
            <div class="canEdite">
              <div class="editeLabel">
                <div>我的提问{{ typeindex + 1 }}</div>
                <dsf-icon
                  class="icon-shanchu"
                  v-if="isview == 0"
                  @click="shanchu(index, typeindex)"
                ></dsf-icon>
              </div>
              <div class="questioncontent">
                <div class="questiontype">
                  <div
                    class="defualttitle"
                    :class="isview == 1 ? 'readonlyTitle' : ''"
                  >
                    <span class="xinghao" v-if="isview == 0">*</span>问题类型
                  </div>
                  <div class="dropcontent">
                    <van-dropdown-menu class="dropdown">
                      <van-dropdown-item
                        v-model="childItem.question_type"
                        :options="item.questionType"
                        @change="change(index, typeindex)"
                        :disabled="isview != 0"
                      />
                    </van-dropdown-menu>
                    <dsf-icon
                      v-if="isview == 0"
                      class="right"
                      name="icon_more"
                    />
                  </div>
                </div>
                <div class="questiondetail">
                  <div
                    class="defualttitle"
                    :class="isview == 1 ? 'readonlyTitle' : ''"
                  >
                    问题描述
                  </div>
                  <div class="filed">
                    <van-field
                      v-model="childItem.content"
                      rows="2"
                      autosize
                      :readonly="isview != 0"
                      type="textarea"
                      @blur="updatefield(index, typeindex)"
                      maxlength="500"
                      placeholder="请输入问题描述"
                      :show-word-limit="isview == 0"
                    />
                  </div>
                </div>
                <div class="files" v-if="(childItem.annex && isview == 1) || isview == 0">
                  <DsfMobileUploadFile
                    label="附件"
                    uploadFileNum="1"
                    inputAlign="left"
                    v-model="childItem.annex"
                    :readOnly="isview == 1"
                    :showDownload="true"
                    @upload-file="uploadfile(index, typeindex)"
                  ></DsfMobileUploadFile>
                </div>
              </div>
            </div>
          </div>
          <div class="addcontent" v-if="isview == 0">
            <dsf-icon class="tianjia icon-add" @click="add(index)"></dsf-icon>
            <!-- <div class="tianjia" @click="add(index)">+</div> -->
            <div class="addtext" @click="add(index)">新增提问</div>
          </div>
        </div>
      </div>
    </div>
    <div class="btns" v-if="isview == 0">
      <div @click="submit(0)" class="save">暂存</div>
      <div @click="submit(1)" class="submit">提交</div>
    </div>
  </div>
</template>

<script>
const testData = [
  {
    title: "本地区、本单位、本部门干部区中最关注的热点问题",
    questionType: [
      { text: "全部商品", value: "全部商品" },
      { text: "新款商品", value: "新款商品" },
      { text: "活动商品", value: "活动商品" },
    ],
    child: [
      {
        question_type: "全部商品",
        content: "sssss",
      },
      {
        question_type: "全部商品",
        content: "sssss",
      },
    ],
  },
  {
    title: "本地区、本单位、本部门干部区中最关注的热点问题是这个",
    questionType: [
      { text: "全部商品1", value: "全部商品1" },
      { text: "新款商品2", value: "新款商品2" },
      { text: "活动商品3", value: "活动商品3" },
    ],
    child: [],
  },
];
export default dsf.component({
  name: "DsfMobileTeasTwoBring",
  mixins: [$mixins.control],
  ctrlCaption: "学员两带来",
  design: {
    isMask: false,
  },
  props: {
    sourcesUrl: {
      type: String,
      default: "/teas/other/twobring/getInfo",
    },
    submitUrl: {
      type: String,
      default: "/teas/other/twobring/submit",
    },
  },
  data() {
    return {
      list: [],
      isview: 0,
    };
  },
  created() {
    if (this.isDesign) {
      this.list = testData;
    } else {
      this.getAddanceInfor();
    }
  },
  methods: {
    uploadfile: function(index, typeindex) {
      console.log(index, typeindex)
    },
    // 类型选择变化
    change(index, typeindex) {
      console.log(index, typeindex);
      this.jugleData(index);
    },
    updatefield: function (index, typeindex) {
      console.log(index, typeindex);
      this.jugleData(index);
    },
    // 新增
    add(index) {
      var outerItem = this.list[index];
      if (outerItem.errorMessage == "问题不能为空") {
        outerItem.errorMessage = "";
      }
      var question_type = outerItem.questionType[0];
      var childItem = {
        question_type: question_type.value,
        content: "",
        annex:null
      };
      outerItem.child.push(childItem);
    },
    shanchu(index, typeindex) {
      var outerItem = this.list[index];
      outerItem.child.splice(typeindex, 1);
      this.jugleData(index);
    },
    jugleData(typeindex) {
      let isType = true;
      let isContent = true;
      let isChild = true;
      this.list.map((item, index) => {
        let type = {};
        if (item.required_value !== "1") {
          return;
        }
        if (typeindex == index) {
          if (item.child.length) {
            item.child.map((childItem, childIndex) => {
              if (type[childItem.question_type]) {
                isType = false;
              } else {
                type[childItem.question_type] = childItem.question_type;
              }
              if (!childItem.content) {
                isContent = false;
              }
            });
          } else {
            isChild = false;
          }
          if (isChild && isContent && isType) {
            item.errorMessage = "";
          } else {
            if (!isChild) {
              item.errorMessage = "问题不能为空";
            }
            if (!isContent) {
              item.errorMessage = "请完善问题描述";
            }
            if (!isType) {
              item.errorMessage = "问题类型不能重复";
            }
          }
        }
      });
    },
    submit(val) {
      // let isType = true;
      // let isContent = true;
      // let isChild = true;
      let isType = [];
      let isContent = [];
      let isChild = [];
      this.list.map((item, index) => {
        let type = {};
        item.ds_order = index;
        if (item.required_value !== "1") {
          // isChild = true;
          // isContent = true;
          item.child?.map((childItem, childIndex) => {
            childItem.ds_order = childIndex;
            if (type[childItem.question_type]) {
              isType.push(item)
              item.errorMessage = "问题类型不能重复";
            } else {
              type[childItem.question_type] = childItem.question_type
            }
          })
        } else {
          if (item.child.length) {
            item.child.map((childItem, childIndex) => {
              childItem.ds_order = childIndex;
              if (type[childItem.question_type]) {
                isType.push(item);
                item.errorMessage = "问题类型不能重复";
              } else {
                type[childItem.question_type] = childItem.question_type;
              }
              if (!childItem.content) {
                isContent.push(item);
                item.errorMessage = "请完善问题描述";
              }
            });
          } else {
            isChild.push(item);
            item.errorMessage = "问题不能为空";
          }
        }
        item.status_value = val;
        item.status_text = val ? '已提交' : '未提交'
      });
      if (isChild.length) {
        dsf.layer.message("请完善问题", false);
        return;
      }
      if (isContent.length) {
        dsf.layer.message("请完善问题", false);
        return;
      }
      if (isType.length) {
        dsf.layer.message("请完善问题", false);
        return;
      }
      if (val) {
        dsf.layer
          .confirm("提交后不可修改，确定提交吗？")
          .then(() => {
            this.submitData(val);
          })
          .catch(() => { });
      } else {
        this.submitData(val);
      }
      
    },
    submitData(val) {
      let loading = dsf.layer.loading();
      let data = {
        classId: dsf.getCookie("class_id") || "",
        stuId: dsf.getCookie("stuId") || "",
        data: JSON.stringify(this.list),
      };
      this.$http
        .post(this.submitUrl, data)
        .done((res) => {
          if (res.success && res.state == 20000) {
            if (val) {
              dsf.layer.message('提交成功', true);
            } else {
              dsf.layer.message('暂存成功', true);
            }
            // this.getAddanceInfor();
            setTimeout(()=> {
              this.$router.go(-1);
            },500)
            this.$dispatch("completed");
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    // 获取信息
    getAddanceInfor() {
      let loading = dsf.layer.loading();
      this.$http
        .get(this.sourcesUrl, {
          classId: dsf.getCookie("class_id"),
          stuId: dsf.getCookie("stuId"),
        })
        .done((res) => {
          console.log(res);
          if (res.success && res.state == 20000) {
            var data = res.data;
            this.dealData(data.data,data.fullData);
            this.isview = data.isview;
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {})
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    dealData(data, fullData) {
      var newData = [];
      for (let index = 0; index < data.length; index++) {
        var newElement = {};
        var element = data[index];
        newElement = element;
        newElement.errorMessage = "";
        var questionType = element.questionType;
        if (fullData) {
           var fullelement = fullData[index];
           questionType = fullelement.questionType
           newElement.required_text = fullelement.required_text;
           newElement.required_value = fullelement.required_value
        } 
        var newquestionType = [];
        for (let typeindex = 0; typeindex < questionType.length; typeindex++) {
          var type = questionType[typeindex];
          newquestionType.push({
            text: type,
            value: type,
          });
        }
        // newquestionType.unshift({
        //     text: '请选择',
        //     value: '请选择'
        // })
        newElement.questionType = newquestionType;
        newData.push(newElement);
      }
      this.list = newData;
      console.log(this.list)
    },
  },
});
</script>